export default [{"description": "Pacific North West - calendar - 8.5x11", "product": "prod_Mn5aZPK3KyV6jK", "price": "price_1M3VP5A8Ti7QZNbkHDNYaLA1"}];